module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"noOfferpublished":"hat noch kein Angebot veröffentlicht.","pageTitle":"Mitgliedschaften"},"en":{"noOfferpublished":"has not published an offer yet.","pageTitle":"Memberships"}}')
  delete Component.options._Ctor
}
